import { DreamRateStatusComponentMap } from "../../../../../constants"

interface Props {
  status: string
  className?: string
}

const DreamRateStatus = ({
  status,
  className = "mr-2 flex items-center"
}: Props) => (
  <div className={className}>{DreamRateStatusComponentMap[status]}</div>
)

export default DreamRateStatus
